
<div  style="display: flex;justify-content: space-evenly;">
  <div *ngFor="let offer of data">
    <div style="height: 100px; width: 100px;" (click)="close(offer.name)">
    <img [src]='offer.img' style="height: 100px; width: 100px;">
    </div>
    <div style="text-align: center;">{{offer.name | titlecase}}</div>
  </div>
</div>